import { useEffect, useState } from 'react';
import { fetchDataFromApi } from './api'; // Ensure this function exists

const useFetchSubData = (url: string, condition: string|any) => {
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<any>(null);
    const fetchData = async () => {
        if (!condition) return null;
        if (condition) {
            setLoading(true);
            try {
                const response = await fetchDataFromApi(url);
                setData(response);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        }
    };
    useEffect(() => {
        fetchData();
    }, [condition, url]); // Added 'url' to the dependency array

    return { data, loading, error, refetch: fetchData };
};

export default useFetchSubData;
